import script from "./ExcelExportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcelExportButton.vue?vue&type=script&setup=true&lang=js"

import "./ExcelExportButton.vue?vue&type=style&index=0&id=21d9d806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d9d806"]])

export default __exports__